import { createAction } from '@reduxjs/toolkit';

export const eventRoomActions = {
  cleanedUp: createAction('[EventRoom] Cleaned up'),
};
